/**
 * Logger function to enable/disable logging
 */
var logger = function() {
    var oldConsoleLog = { log: console.log, info: console.info, error: console.error };
    var pub = {};

    pub.enableLogger = function enableLogger() {
        window['console']['log'] = oldConsoleLog.log;
        window['console']['info'] = oldConsoleLog.info;
        window['console']['error'] = oldConsoleLog.error;
    };

    pub.disableLogger = function disableLogger() {
        window['console']['log'] = function() {};
        window['console']['info'] = function() {};
        window['console']['error'] = function() {};
    };

    return pub;
}();

logger.disableLogger();
if (_APP && _APP['STAGE'] == "development") {
    logger.enableLogger();
}